<template>
    <div>
        <el-row>
            <el-card class="box-card">
                <span>店铺装修</span>
            </el-card>
        </el-row>

        <el-row style="margin-top: 30px">
            <el-card class="box-card" style="height: 80vh">
                <div style="display: flex">
                    <iframe
                        src="https://kegong.anyixuanyouxuan.com"
                        frameborder="0"
                        style="height: 70vh; width: 375px; border-radius: 10px; box-shadow: 0px 5px 5px 5px #e9e9e9"
                    ></iframe>
                    <div style="margin-left: 40px; flex: 1; width: 0">
                        <div><el-button type="primary" @click="addHome()">新增模板</el-button></div>
                        <el-table :data="data" style="width: 100%; margin-top: 20px" header-row-class-name="setHeaderBack">
                            <el-table-column type="index" label="序号" width="100px"> </el-table-column>
                            <el-table-column label="模板名称"> </el-table-column>
                            <el-table-column label="模板类型"> </el-table-column>
                            <el-table-column label="添加时间"> </el-table-column>
                            <el-table-column label="更新时间"> </el-table-column>
                            <el-table-column label="操作">
                                <template>
                                    <el-button type="text">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: []
        };
    },
    methods: {
        addHome() {
            this.$router.push({
                path: '/addHome'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .setHeaderBack th {
    background: #b2cbf1 !important;
    color: #333 !important;

    .cell {
        color: #333 !important;
    }
}
</style>